import { render } from "./policies-page.vue?vue&type=template&id=bdbb03fc"
import script from "./policies-page.vue?vue&type=script&lang=js"
export * from "./policies-page.vue?vue&type=script&lang=js"

import "./policies-page.vue?vue&type=style&index=0&id=bdbb03fc&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__